import { gql } from '@apollo/client';

export const DOWNLOAD_SHOPIFY_CUSTOMERS = gql`
  mutation DownloadShopifyCustomers {
    downloadShopifyCustomers {
      errors { path, message }
    }
  }
`;

export const SHOPIFY_MERGE_SUGGESTIONS = gql`
  query ShopifyMergeSuggestions {
    shopifyMergeSuggestions {
      term
      customers {
        id
        gid
        firstName
        lastName
        fullName
        url
        phone
        email
        ordersCount

        addresses {
          id
          fullName
          street
          city
          state
          zip
          phone
        }
      }
    }
  }
`;
